import HeaderContainer from "components/common/PanelLayout/Header/HeaderContainer";
import Text from "components/common/Text/Text";
import * as React from "react";
import { Routes } from "router";
import OnboardingContainer from "screens/Onboarding/Onboarding.container";
import styled from "styled-components";

export interface IHeaderProps {
  title?: string;
  titleSecondary?: string;
  rightTitle?: string;
  history?: {
    goBack: () => void;
  };
  infoComponent?: React.ReactNode;
  actionComponent?: React.ReactNode;
  closeButtonHandler?: boolean;
  clearSession?: boolean;
  backButtonHandler?(): void;
  arrowButtonHandler?(): void;
}

const Header = ({
  closeButtonHandler,
  backButtonHandler,
  title,
  titleSecondary,
  rightTitle,
  history,
  infoComponent,
  clearSession
}: IHeaderProps) => {
  const { goTo } = OnboardingContainer.useContainer();

  const showRightTitle = () =>
    !(closeButtonHandler || backButtonHandler || infoComponent);

  const handleGoToHomeScreen = (
    event?: React.SyntheticEvent<HTMLSpanElement>
  ) => {
    goTo({ route: Routes.Home, clearSession });
  };

  const generateTitle = () => {
    if (titleSecondary) {
      return (
        <>
          <HeaderTitle h3 light center white>
            {title}
          </HeaderTitle>
          <Spacer h1 light center white spaced>
            |
          </Spacer>
          <Text h3 light center tertiary>
            {titleSecondary}
          </Text>
        </>
      );
    }
    return (
      <HeaderTitle h3 light center white>
        {title}
      </HeaderTitle>
    );
  };

  return (
    <HeaderContainer>
      <LeftHeader className="left" rightTitle={rightTitle}>
        <LeftTitleSection className="leftTitle">
          {generateTitle()}
        </LeftTitleSection>
      </LeftHeader>
      <RightHeader className="right" rightTitle={rightTitle}>
        {showRightTitle() && (
          <RightTitleSection className="rightTitle">
            <HeaderTitle h3 light center tertiary>
              {rightTitle}
            </HeaderTitle>
          </RightTitleSection>
        )}
        <RightActionSection className="rightAction">
          {backButtonHandler && (
            <Text
              h4
              tertiary
              onClick={backButtonHandler}
              style={{ paddingLeft: "1rem" }}
            >
              Back
            </Text>
          )}
          {closeButtonHandler && (
            <Text
              h4
              tertiary
              onClick={handleGoToHomeScreen}
              style={{ paddingLeft: "1rem" }}
            >
              Close
            </Text>
          )}
          {infoComponent}
        </RightActionSection>
      </RightHeader>
    </HeaderContainer>
  );
};

const HeaderTitle = styled(Text)`
  text-transform: none;
`;

const Spacer = styled(Text)`
  padding: 0 1vh;
`;

const LeftHeader = styled.div`
  ${({ rightTitle }: IHeaderProps) => `
  position: relative;
  flex: 1 1 ${rightTitle ? "60%" : "80%"};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 4vh;
`}
`;

const LeftTitleSection = styled.div``;

const RightHeader = styled.div`
  ${({ rightTitle }: IHeaderProps) => `
  flex: 1 1 ${rightTitle ? "40%" : "20%"};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`}
`;

const RightActionSection = styled.div`
  position: absolute;
  right: 4vh;
`;
const RightTitleSection = styled.div``;

export default Header;



// WEBPACK FOOTER //
// ./src/components/common/PanelLayout/Header/Header.tsx